import React, { useContext, useEffect, useState } from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import "./ViewChart.css";
import {
  DTOAnalyticsStartup,
  DTOStartupDetailsViewDataset,
  DTOStartupViewDataset,
} from "components/types";
import { Flex, TitlePage, Txt, ViewChartDetailsRow } from "components/atoms";
import { ViewChartWidget } from "components/molecules";
import { getAnalytics } from "api/Api";
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext";
import {
  placeholderDataset,
  detailsPlaceholderViewDataset,
} from "shared/const";

export const ViewChart = () => {
  const ctx = useContext(AppGeneralContext);
  const [datasets, setDatasets] = useState<DTOAnalyticsStartup | null>(null);
  const [isLoadingDatasets, setIsLoadingDatasets] = useState<boolean>(false);
  useEffect(() => {
    const getPageData = async () => {
      setIsLoadingDatasets(true);
      const resp = await getAnalytics();
      if (!resp.response || !resp.isSuccess) {
        setIsLoadingDatasets(false);
        setDatasets({
          chartDataset: placeholderDataset,
          detailsDataset: detailsPlaceholderViewDataset,
        });
        const errorMessage = resp.error
          ? resp.error
          : `No view data available!`;
        ctx.setErrorModal(errorMessage);
        return;
      }
      console.log(resp.response.data.chartDataset);
      setDatasets(resp.response.data);
      setIsLoadingDatasets(false);
    };
    getPageData();
    return () => {
      setDatasets(null);
    };
  }, []);

  return (
    <div className="viewChart-container">
      <TitlePage as={"h3"} title="Profile views per month" />
      <div className="viewChart-respContainer">
        <ResponsiveContainer className={"viewChart-common"}>
          <LineChart
            data={ datasets?.chartDataset }
            margin={{ left: -15, right: 40, top: 5 }}
          >
            <XAxis fontSize={"10px"} stroke="0" dataKey="month" />
            <YAxis fontSize={"10px"} stroke="0" allowDecimals={false}/>
            <Line type="monotone" dataKey="views" stroke={"var(--primary)"} />
            <Tooltip />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <ViewChartWidget
        isLoading={isLoadingDatasets}
        dataset={
          datasets?.detailsDataset
        }
        wrapperClass="viewChart-common"
      />
    </div>
  );
};
